import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ShoppingCart, User, Heart, Menu, Search } from 'lucide-react';

const Header = ({ showBackButton = false, cartCount = 0 }) => {
    const navigate = useNavigate();

    return (
        <header className="bg-white border-b border-gray-200 sticky top-0 z-50 shadow-sm">
            <div className="container mx-auto px-4 lg:px-8">
                {/* Top Bar */}
                <div className="flex justify-between items-center py-4 lg:py-5">
                    {/* Logo */}
                    <div className="flex items-center gap-4">
                        {showBackButton && (
                            <button
                                onClick={() => navigate(-1)}
                                className="text-gray-900 hover:text-gray-600 transition-colors"
                            >
                                ←
                            </button>
                        )}
                        <h1
                            onClick={() => navigate('/template9')}
                            className="text-2xl lg:text-3xl font-bold text-gray-900 cursor-pointer tracking-tight"
                        >
                            CHIC BOUTIQUE
                        </h1>
                    </div>

                    {/* Right Icons */}
                    <div className="flex items-center gap-4 lg:gap-6">
                        <Search className="w-5 h-5 text-gray-900 cursor-pointer hover:text-gray-600 transition-colors" />
                        <Heart className="w-5 h-5 text-gray-900 cursor-pointer hover:text-gray-600 transition-colors" />
                        <div className="relative cursor-pointer" onClick={() => navigate('/template9/cart')}>
                            <ShoppingCart className="w-5 h-5 text-gray-900 hover:text-gray-600 transition-colors" />
                            {cartCount > 0 && (
                                <span className="absolute -top-2 -right-2 bg-gray-900 text-white text-xs w-5 h-5 rounded-full flex items-center justify-center font-medium">
                                    {cartCount}
                                </span>
                            )}
                        </div>
                        <User
                            className="w-5 h-5 text-gray-900 cursor-pointer hover:text-gray-600 transition-colors"
                            onClick={() => navigate('/template9/profile')}
                        />
                    </div>
                </div>

                {/* Navigation Menu */}
                <nav className="border-t border-gray-200">
                    <div className="flex justify-center items-center gap-8 lg:gap-12 py-4">
                        <button
                            onClick={() => navigate('/template9')}
                            className="text-sm lg:text-base font-medium text-gray-900 hover:text-gray-600 transition-colors uppercase tracking-wide"
                        >
                            Home
                        </button>
                        <button
                            onClick={() => navigate('/template9/shop')}
                            className="text-sm lg:text-base font-medium text-gray-900 hover:text-gray-600 transition-colors uppercase tracking-wide"
                        >
                            Shop
                        </button>
                        <button
                            onClick={() => navigate('/template9/about')}
                            className="text-sm lg:text-base font-medium text-gray-900 hover:text-gray-600 transition-colors uppercase tracking-wide"
                        >
                            About
                        </button>
                        <button
                            onClick={() => navigate('/template9/contact')}
                            className="text-sm lg:text-base font-medium text-gray-900 hover:text-gray-600 transition-colors uppercase tracking-wide"
                        >
                            Contact
                        </button>
                        <button
                            onClick={() => navigate('/template9/orders')}
                            className="text-sm lg:text-base font-medium text-gray-900 hover:text-gray-600 transition-colors uppercase tracking-wide"
                        >
                            Orders
                        </button>
                    </div>
                </nav>
            </div>
        </header>
    );
};

export default Header;
